import { ChangeDetectionStrategy, Component, input, viewChild } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { LoadingShimmerComponent } from '../../../loading-shimmer/loading-shimmer.component';
import {
  NgxFloatUiContentComponent,
  NgxFloatUiDirective,
  NgxFloatUiPlacements,
  NgxFloatUiTriggers,
} from 'ngx-float-ui';

@Component({
  selector: 'lib-options-table-cell',
  imports: [MatIcon, LoadingShimmerComponent, NgxFloatUiContentComponent, NgxFloatUiDirective],
  templateUrl: './options-table-cell.component.html',
  styleUrl: './options-table-cell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OptionsTableCellComponent {
  options = input.required<OptionsTableCellOption[]>();
  loading = input.required<boolean>();
  floatUiDirective = viewChild<NgxFloatUiDirective>('floatUiDirective');
  protected readonly NgxFloatUiPlacements = NgxFloatUiPlacements;
  protected readonly NgxFloatUiTriggers = NgxFloatUiTriggers;

  protected optionClicked(option: OptionsTableCellOption) {
    option.optionSelected();
    this.floatUiDirective()?.hide();
  }
}

export interface OptionsTableCellOption {
  title: string;
  optionSelected: () => void;
}
